import { DivConst } from 'constants/divConst';
import type { ContentSearchItemType } from 'types/api/contentSearchResponseType';

export interface ContentCopyApi {
  postQuizCopy: (req: { quizId: number }) => Promise<void>;
  postDiagnosisCopy: (req: { diagnosisId: number }) => Promise<void>;
  postFormCopy: (req: { formId: number }) => Promise<void>;
  postVoiceChatCopy: (req: { voiceChatId: number }) => Promise<void>;
}

/**
 * contentsTypeDiv に応じて対応する copy API を呼ぶ。
 * 未知の type の場合は何もしない（旧コード default: break と同じ挙動）。
 */
export async function dispatchContentCopy(
  content: ContentSearchItemType,
  api: ContentCopyApi
): Promise<void> {
  switch (content.contentsTypeDiv) {
    case DivConst.items.contentsType.quiz.value:
      await api.postQuizCopy({ quizId: content.id });
      return;
    case DivConst.items.contentsType.diagnosis.value:
      await api.postDiagnosisCopy({ diagnosisId: content.id });
      return;
    case DivConst.items.contentsType.form.value:
      await api.postFormCopy({ formId: content.id });
      return;
    case DivConst.items.contentsType.voiceChat.value:
      await api.postVoiceChatCopy({ voiceChatId: content.id });
      return;
    default:
      return;
  }
}
